import { render } from "./Authentication.vue?vue&type=template&id=1547a458&scoped=true"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"

import "./Authentication.vue?vue&type=style&index=0&id=1547a458&scoped=true&lang=css"

import exportComponent from "/home/lyonjo5/lyon-marketing-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1547a458"]])

export default __exports__